import { useEffect, useState } from 'react'
import { Button, Segment, Popup } from 'semantic-ui-react'
import './style.less'
import { useHistory, useParams } from 'react-router-dom'
import StorePrioritario from './store'
import FormAtribuir from '../../components/FormAtribuir'
import { useStore } from '../../stores/useStoreProfile'
import FormItemPrioritario from '../../components/FormItemPrioritario'
import { CardForm } from '../../components/CardForm'

const FormPrioritario = () => {
  const history = useHistory()
  const { store, api } = StorePrioritario()
  const { id } = useParams<{ id: string }>()
  const [popupConfirm, setPopupConfirm] = useState(false)

  const { store: profile, dominios } = useStore()
  const { permissions } = profile

  useEffect(() => {
    if (id) api.get(Number(id))
  }, [id])  // eslint-disable-line

  const podeEditar = Boolean(permissions.add_itemtrabalho.find((e: any) =>
    (e.departamento === store.departamento?.toString()) ||
    (e.departamento && !store.id)
  ))
  const podeAtribuir = Boolean(permissions.add_relator.find((e: any) =>
    (e.departamento === store.departamento?.toString()) &&
    store.areas_relatoras?.map(a => String(a.id)).includes(e.area_relatora)
  )) && store.alias_situacao === 'em_andamento'

  return <CardForm
    requerAtencao={store?.requer_atencao}
    novo={store?.novo}
    titulo={!podeEditar ? store.titulo : undefined}
  >
    <FormItemPrioritario
      store={store}
      modoEdicao={podeEditar}
      editarDescricao={podeAtribuir}
      loading={api.checkLoading('get')}
      checkError={api.checkError}
      checkSucess={api.checkSucess}
      setStore={api.setStore}
      departamento={dominios.departamento}
      filtroDepartamento={
        podeEditar
          ? permissions.add_itemtrabalho.map((e: any) => Number(e.departamento))
          : store.departamento ? [store.departamento] : []
      }
    />

    {/* Botões do formulário */}
    {podeEditar &&
      <Segment basic clearing >
        <Button name="btn-fechar-form" floated='left' onClick={() => history.goBack()}>
          Cancelar/Fechar
        </Button>
        <Button
          name="btn-priori-salvarpublicar"
          floated='right'
          onClick={() => api.saveSend()}
          disabled={api.checkLoading('saveSend') ||
            !(!store.alias_situacao || store.alias_situacao === 'em_elaboracao') ||
            (store.id || 0) < 0}
        >
          Salvar e enviar
        </Button>
        <Button
          name="btn-priori-salvar"
          floated='right'
          onClick={() => api.save()}
          disabled={api.checkLoading('save') || (store.id || 0) < 0}
        >
          Salvar
        </Button>
        <Button
          name="btn-priori-concluir"
          floated='right'
          onClick={() => api.concluir()}
          disabled={api.checkLoading('concluir') ||
            store.alias_situacao !== 'em_andamento' ||
            (store.id || 0) < 0}
        >
          Concluir
        </Button>

        <Popup
          trigger={
            <Button
              name="btn-priori-excluir"
              floated='right'
              disabled={api.checkLoading('del') || (store.id || -1) < 0}
            >
              Excluir
            </Button>
          }
          on='click'
          open={popupConfirm}
          onClose={() => setPopupConfirm(false)}
          onOpen={() => setPopupConfirm(true)}
        >
          <Popup.Header>Confirma exclusão?</Popup.Header>
          <Popup.Content>
            <Button name="btn-cancela-excluirprio" onClick={() => setPopupConfirm(false)}>Não</Button>
            <Button name="btn-confirma-excluirprio"
              onClick={async () => {
                setPopupConfirm(false)
                const deleted = await api.del()
                if (deleted) setTimeout(() => { history.goBack() }, 1000)
              }}
              primary
              floated='right'
            >Sim</Button>
          </Popup.Content>
        </Popup>

        <Button
          name="btn-priori-solicitar-relato"
          floated='right'
          onClick={() => api.solicitarRelato()}
          disabled={api.checkLoading('solicitar-relato') ||
            store.alias_situacao !== 'em_andamento' ||
            (store.id || 0) < 0}
        >
          Solicitar relato
        </Button>

      </Segment>
    }

    {/* Formulário Atribuir */}
    {podeAtribuir &&
      <FormAtribuir itemTrabalho={store} />
    }
  </CardForm>
}

export default FormPrioritario
